import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MenuCM from "components/shared/menu";
import ProfileMenuCM from "components/profilemenu";
import FooterCM from "components/shared/footer";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import PaginationCM from "components/shared/Pagination";
import ContactCM from "components/contactus";
import {
  StyledCardContent,
  StyledCard,
  StyledTypography,
  StyledNewMessage,
  StyledCardActions,
  StyledContainer,
  StyledSpan,
  StyledPaper,
  StyledDivIcon,
  StyledDivtext,
} from "./Ticket.style";
import { getContactUsRequest, getTicketsRequest } from "api/requests";
import useHttp from "hooks/use-http";
import { PAGINATION_LIMIT } from "constants";
import LoadingCM from "components/shared/Loading";
import { BsInstagram, BsTelegram, BsWhatsapp } from "react-icons/bs";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import Button from "@mui/material/Button";
import {Helmet} from "react-helmet";

export default function Messages() {
  const { request, loading } = useHttp();
  const [page, setPage] = useState(1);
  const [contact, setContact] = useState([]);

  const getMessages = useCallback(async () => {
    let resContact = await request({
      url: getContactUsRequest,
      values: {},
    });
    setContact(resContact);
  }, [page, request]);

  useEffect(() => {
    getMessages();
  }, []);

  return (
    <>
      {loading && <LoadingCM />}
      <Helmet>
        <title>پشتیبانی - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      <MenuCM Background pageTitle="پشتیبانی" />
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Paper p={2}>
              <CardContent>
                <div style={{ textAlign: "center" }}>
                  <div style={{ marginBottom: "20px" }}>
                    در حال حاضر امکان پاسخگویی به شما وجود ندارد. برای پشتیبانی
                    میتوانید از راه های زیر اقدام فرمایید یا وارد حساب کاربری
                    خود شوید.
                  </div>
                  <Link to={`/login`}>
                    <Button variant="outlined">
                      <span style={{ marginRight: "10px", marginLeft: "10px" }}>
                        ورود به حساب کاربری
                      </span>
                    </Button>
                  </Link>
                </div>
              </CardContent>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} mb={10}>
            <Grid container spacing={2}>
              <Grid item md={6} xs={12}>
                <StyledPaper
                  elevation={3}
                  sx={{
                    display: "flex",
                    marginTop: "3px",
                    marginBottom: "3px",
                  }}
                >
                  <StyledDivIcon>
                    <PhoneIcon />
                  </StyledDivIcon>
                  <StyledDivtext>
                    <h4>شماره تماس</h4>
                    <p>
                      <a href={"tel:" + contact?.a?.phone_number}>
                        مبلمان :{" "}
                        <span style={{ color: "#4b4b4b" }}>
                          {contact?.a?.phone_number}
                        </span>
                      </a>
                    </p>
                    <p>
                      <a href={"tel:" + contact?.b?.phone_number}>
                        اکسسوری :{" "}
                        <span style={{ color: "#4b4b4b" }}>
                          {contact?.b?.phone_number}
                        </span>
                      </a>
                    </p>
                  </StyledDivtext>
                </StyledPaper>
              </Grid>
              <Grid item md={6} xs={12}>
                <StyledPaper
                  elevation={3}
                  sx={{ display: "flex", marginTop: "2px" }}
                >
                  <StyledDivIcon>
                    <BsInstagram size="26" />
                  </StyledDivIcon>
                  <StyledDivtext>
                    <h4>اینستاگرام</h4>
                    <p>
                      <a
                        href={
                          "https://www.instagram.com/" + contact?.a?.instagram
                        }
                        target="_blank"
                      >
                        مبلمان :{" "}
                        <span style={{ color: "#4b4b4b" }}>
                          {contact?.a?.instagram}
                        </span>
                      </a>
                    </p>
                    <p>
                      <a
                        href={
                          "https://www.instagram.com/" + contact?.b?.instagram
                        }
                        target="_blank"
                      >
                        اکسسوری :{" "}
                        <span style={{ color: "#4b4b4b" }}>
                          {contact?.b?.instagram}
                        </span>
                      </a>
                    </p>
                  </StyledDivtext>
                </StyledPaper>
              </Grid>
              <Grid item md={6} xs={12}>
                <StyledPaper
                  elevation={3}
                  sx={{
                    display: "flex",
                    marginTop: "2px",
                    marginBottom: "20px",
                  }}
                >
                  <StyledDivIcon>
                    <BsTelegram size="26" />
                  </StyledDivIcon>
                  <StyledDivtext>
                    <h4>تلگرام</h4>
                    <p>
                      <a
                        href={"https://t.me/" + contact?.a?.telegram}
                        target="_blank"
                      >
                        مبلمان :{" "}
                        <span style={{ color: "#4b4b4b" }}>
                          {contact?.a?.telegram}
                        </span>
                      </a>
                    </p>
                    <p>
                      <a
                        href={"https://t.me/" + contact?.b?.telegram}
                        target="_blank"
                      >
                        اکسسوری :{" "}
                        <span style={{ color: "#4b4b4b" }}>
                          {contact?.b?.telegram}
                        </span>
                      </a>
                    </p>
                  </StyledDivtext>
                </StyledPaper>
              </Grid>
              <Grid item md={6} xs={12}>
                <StyledPaper
                  elevation={3}
                  sx={{
                    display: "flex",
                    marginTop: "2px",
                    marginBottom: "20px",
                  }}
                >
                  <StyledDivIcon>
                    <BsWhatsapp size="26" />
                  </StyledDivIcon>
                  <StyledDivtext>
                    <h4>واتساپ</h4>
                    <p>
                      <a
                        href={"https://wa.me/" + contact?.a?.email}
                        target="_blank"
                      >
                        مبلمان :{" "}
                        <span style={{ color: "#4b4b4b" }}>
                          {contact?.a?.email}
                        </span>
                      </a>
                    </p>
                    <p>
                      <a
                        href={"https://wa.me/" + contact?.b?.email}
                        target="_blank"
                      >
                        اکسسوری :{" "}
                        <span style={{ color: "#4b4b4b" }}>
                          {contact?.b?.email}
                        </span>
                      </a>
                    </p>
                  </StyledDivtext>
                </StyledPaper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <ContactCM All />
      <FooterCM />
    </>
  );
}
